export const getters = {
  getIsInboxHasAi: (_state) => _state.isInboxHasAi,

  getInboxAiName: (_state) => _state.inboxAiName,

  getIsAiChatHandover: (_state) => _state.isAiChatHandover,

  getAiNests: (_state) => _state.aiNests,

  getUiFlags: (_state) => _state.uiFlags,
};
